//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

    // note: Due to the way JS Dates work, the date-time-picker always has to work in terms of the browser's native time zone.
    // This means we have to convert the initial time and any changed time sent via the time changed callback.
  curalate.directive('dateTimePicker', ['DateTimeService',
    function(DateTimeService) {
      const pad = function(value) {
        return (angular.isDefined(value) && value.toString().length < 2) ? `0${value}` : value;
      };

      return {
        restrict: 'E',
        scope: {
          disabled: '@',
          time: '=ngModel',
          timeChangedCallback: '&dateTimeChanged',
          before: '=?',
          after: '=?',
          mode: '@?',
          position: '@?',
        },
        replace: true,
        require: ['ngModel', '^?form'],
        template: require('@partials/date-time-picker.html'),
        controller: ['$scope',
          function($scope) {
            let initialTime;

            if ($scope.time) {
                            // First shift the time to the user's time zone and then strip the time zone, so we get the same
                            // date time but in the browser's native time zone.
              initialTime = DateTimeService.applyBrowserTimeZone(DateTimeService.userMoment($scope.time));
            } else {
                            // set initial time to the next hour
              initialTime = DateTimeService.roundNow().add('h', 1);
            }

            const refreshInternalState = function() {
              const hours = $scope.picker.time.getHours();
              const meridianHrs = (hours === 0 || hours === 12) ? 12 : hours % 12; // Convert to 12-hour system

              $scope.picker.internal.hours = pad(meridianHrs);
              $scope.picker.internal.minutes = pad($scope.picker.time.getMinutes());
              $scope.picker.internal.meridian = hours < 12 ? 'AM' : 'PM';
            };

            $scope.$watch('picker.time', (newVal, oldVal) => {
              let dateTime;
              if (oldVal !== newVal) {
                dateTime = DateTimeService.applyUserTimeZone($scope.picker.time).toDate();
                $scope.timeChangedCallback({ dateTime });
                $scope.ngModel = dateTime;
              }
            });

            $scope.picker = {
              isOpen: false,
              position: $scope.position || 'top',
              time: initialTime.toDate(),
              today: new Date(),
              timeZoneLabel: DateTimeService.getShortTimeZoneName(),
                            // $scope.picker.internal is used when the date-time-picker is in "separate" mode
                            // it's really a rework of ui-bootstrap's time-picker, but less annoying and with customizable style
              internal: {
                meridian: 'AM',
                date: initialTime.toDate(),
                hours: initialTime.toDate().getHours(),
                minutes: initialTime.toDate().getMinutes(),
                dateChanged: _.debounce(() => {
                  const parsedDate = moment($scope.picker.internal.date);
                  const currentDateObj = new Date($scope.picker.time.getTime());

                  currentDateObj.setFullYear(parsedDate.year(), parsedDate.month(), parsedDate.date());

                  $scope.$apply(() => {
                    $scope.picker.time = currentDateObj;
                  });
                }, 100),
                hoursChanged: _.debounce(() => {
                  let newDateTime;
                  let hours;

                  if ($scope.picker.time && !isNaN($scope.picker.internal.hours)) {
                    newDateTime = new Date($scope.picker.time.getTime());
                    hours = $scope.picker.internal.hours;

                    if (hours === 12 && $scope.picker.internal.meridian === 'AM') {
                      hours = 0;
                    }

                    newDateTime.setHours(hours);
                    $scope.$apply(() => {
                      $scope.picker.time = newDateTime;
                      $scope.picker.internal.meridian = $scope.picker.time.getHours() < 12 ? 'AM' : 'PM';
                    });
                  }
                }, 100),
                minutesChanged: _.debounce(() => {
                  let newDateTime;
                  if ($scope.picker.time && !isNaN($scope.picker.internal.minutes)) {
                    newDateTime = new Date($scope.picker.time.getTime());
                    newDateTime.setMinutes($scope.picker.internal.minutes);

                    $scope.$apply(() => {
                      $scope.picker.time = newDateTime;
                      $scope.picker.internal.meridian = $scope.picker.time.getHours() < 12 ? 'AM' : 'PM';
                    });
                  }
                }, 100),
                toggleMeridian() {
                  const momentTime = moment($scope.picker.time);

                  if ($scope.picker.internal.meridian === 'AM') {
                    $scope.picker.time = momentTime.add(12, 'hours').toDate();
                  } else {
                    $scope.picker.time = momentTime.subtract(12, 'hours').toDate();
                  }

                  refreshInternalState();
                },
              },
            };

            $scope.$watch('picker.internal.date', (oldVal, newVal) => {
              if (!angular.equals(oldVal, newVal)) {
                $scope.picker.internal.dateChanged();
              }
            });

            refreshInternalState();
          },
        ],
        link(scope, element, attrs, ctrls) {
          const $window = angular.element(window);
          const ngModel = ctrls[0];
          const formCtrl = ctrls[1];
          const beforeChecker = function(modelValue) {
            return scope.before && moment(modelValue).isBefore(scope.before);
          };
          const afterChecker = function(modelValue) {
            return scope.after && moment(modelValue).isAfter(scope.after);
          };

          if (formCtrl) {
            formCtrl.$addControl(ngModel);
          }

                    // Reset the view value on change of "ngModel", "before", and "after"
          _(['before', 'after']).each((exp) => {
            scope.$watch(exp, ngModel.$validate);
          });

                    // Set the initial view value of the model
          scope.ngModel = DateTimeService.applyUserTimeZone(scope.picker.time).toDate();
          ngModel.$setViewValue(scope.picker.time);

          if (angular.isDefined(attrs.before)) {
            ngModel.$setValidity('before', true);
            ngModel.$validators.before = beforeChecker;
          }

          if (angular.isDefined(attrs.after)) {
            ngModel.$setValidity('after', true);
            ngModel.$validators.after = afterChecker;
          }

          if (scope.mode === 'separate') {
            ngModel.$parsers.unshift((value) => {
              let hours = parseInt(scope.picker.internal.hours, 10);
              const minutes = parseInt(scope.picker.internal.minutes, 10);

              if (scope.picker.internal.meridian === 'PM') {
                hours += 12;
              }

              value.setHours(hours);
              value.setMinutes(minutes);

              return value;
            });
          }

                    // Close the date popover if the user clicks outside of the popover AND NOT on the toggle button
          const windowClickCallback = function(event) {
            const target = angular.element(event.target);
            const toggleButton = element.find('.btn[popover-trigger]');
            const isToggleBtn = angular.isDefined(target.closest('.btn').attr('popover-trigger'));
            const datepicker = element.find('.popover');

            if (!isToggleBtn &&                         // If the click event wasn't on the trigger button
                            datepicker.scope() &&                   // If the datepicker's scope exists
                            datepicker.scope().tt_isOpen &&         // If the datepicker is open
                            datepicker.find(target).length === 0    // If the click event was not within the datepicker tooltip
                        ) {
              toggleButton.trigger('click');
              scope.$apply();
            }
          };

          $window.on('click.date-picker', windowClickCallback);
          scope.$on('$destroy', () => { $window.off('click.date-picker'); });
        },
      };
    },
  ]);
})();
